import {
  convertLegacyAppOptions,
  convertLegacyRouteRefs,
} from '@backstage/core-compat-api';
import { createApp } from '@backstage/frontend-defaults';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';
import catalogUnprocessedEntitiesPlugin from '@backstage/plugin-catalog-unprocessed-entities/alpha';
import devtoolsPlugin from '@backstage/plugin-devtools/alpha';
import entityPreviewPlugin from '@schibsted/backstage-plugin-entity-preview-react/alpha';
import featurePlugin from '@schibsted/backstage-plugin-feature-react/alpha';
import gettingStartedPlugin from './extensions/gettingStartedPlugin';
import servicePortalPlugin from './extensions/servicePortalPlugin';
import { orgPlugin } from '@backstage/plugin-org';
import searchAlphaPlugin from '@backstage/plugin-search/alpha';
import { techDocsTextSizeAddonModule } from '@backstage/plugin-techdocs-module-addons-contrib/alpha';
import announcementsPlugin from '@backstage-community/plugin-announcements/alpha';
import argocdPlugin, {
  argocdTranslationsModule,
} from '@backstage-community/plugin-argocd';
import explorePlugin from '@backstage-community/plugin-explore/alpha';
import githubActionsPlugin from '@backstage-community/plugin-github-actions/alpha';
import scaffolderAlphaPlugin from '@backstage/plugin-scaffolder/alpha';
import techDocsMermaidAddonModule from 'backstage-plugin-techdocs-addon-mermaid/alpha';
import gitHubPullRequestsApi from '@roadiehq/backstage-plugin-github-pull-requests/alpha';

import * as plugins from './plugins';
import { appExtensionsModule } from './extensions/appModule';
import { apiDocsModule } from './extensions/apiDocsModule';
import { entityPageModule } from './extensions/entityPage';
import {
  customCatalogPlugin,
  customApiDocsPlugin,
  customTechdocsPlugin,
  customUserSettingsPlugin,
  devtoolsExtraPages,
} from './extensions/pluginOverrides';
import { appModuleHome } from './components/home/Home';

const convertedOptionsModule = convertLegacyAppOptions({
  plugins: Object.values(plugins),
  featureFlags: [
    {
      pluginId: '',
      name: 'features-entity-enabled',
      description: 'Enables the Features menu item in the sidebar',
    },
    {
      pluginId: '',
      name: 'features-tab-enabled',
      description: 'Enables the FEATURES tab in the component view',
    },
    {
      pluginId: '',
      name: 'code-insights-enabled',
      description: 'Enables the Code Insights tab in the component view',
    },
    {
      pluginId: '',
      name: 'datadog-insights-enabled',
      description: 'Enables the Datadog tab in the component view',
    },
  ],
});

const app = createApp({
  features: [
    customCatalogPlugin,
    appModuleHome,
    searchAlphaPlugin,
    customApiDocsPlugin,
    devtoolsPlugin,
    devtoolsExtraPages,
    entityPreviewPlugin,
    featurePlugin,
    gettingStartedPlugin,
    servicePortalPlugin,
    customTechdocsPlugin,
    catalogGraphPlugin,
    catalogUnprocessedEntitiesPlugin,
    scaffolderAlphaPlugin,
    customUserSettingsPlugin,
    explorePlugin,
    githubActionsPlugin,
    gitHubPullRequestsApi,
    announcementsPlugin,
    techDocsTextSizeAddonModule,
    techDocsMermaidAddonModule,
    convertedOptionsModule,
    appExtensionsModule,
    apiDocsModule,
    entityPageModule,
    argocdPlugin,
    argocdTranslationsModule,
  ],
  bindRoutes({ bind }) {
    bind(customCatalogPlugin.externalRoutes, {
      createComponent: scaffolderAlphaPlugin.routes.root,
      viewTechDoc: customTechdocsPlugin.routes.docRoot,
      createFromTemplate: scaffolderAlphaPlugin.routes.selectedTemplate,
    });
    bind(scaffolderAlphaPlugin.externalRoutes, {
      viewTechDoc: customTechdocsPlugin.routes.docRoot,
    });
    bind(convertLegacyRouteRefs(orgPlugin.externalRoutes), {
      catalogIndex: customCatalogPlugin.routes.catalogIndex,
    });
  },
});

export default app.createRoot();
